import { SearchSelectbox } from "cpl-react-common/components/Inputs/SearchSelectbox";
import { useSelector } from "react-redux";
import {
  getPurchaseAccountSelectModels,
  selectPurchaseAccountSelectModels,
  selectLoading,
  selectLastUpdateTime,
} from "./components/PurchaseAccountSelectSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";

type PurchaseAccountSelectProps = {
  "data-test-id"?: string;
  handleChange: (selection: GuidSelectModel) => void;
  defaultSelectedValue?: string;
  disabled?: boolean;
  enableReinitialise?: boolean;
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 60; // 1 hour

const PurchaseAccountSelect: React.FC<PurchaseAccountSelectProps> = ({
  "data-test-id": testId,
  handleChange,
  defaultSelectedValue,
  disabled,
  enableReinitialise,
}) => {
  const loading = useSelector(selectLoading);
  const purchaseAccountSelectModels = useSelector(selectPurchaseAccountSelectModels);
  const lastUpdateTime = useSelector(selectLastUpdateTime);
  const thunkDispatch = useThunkDispatch();

  const updateSelectModels = () => {
    thunkDispatch(getPurchaseAccountSelectModels());
  };

  const defaultSelected = purchaseAccountSelectModels.find((x) => x.value === defaultSelectedValue);

  return (
    <ActivityIndicator isBusy={loading}>
      <SearchSelectbox
        data-test-id={testId}
        handleChange={(selection) => {
          handleChange(new GuidSelectModel({ value: selection.value.toString(), label: selection.label }));
        }}
        selectOptions={purchaseAccountSelectModels.map((x) => ({
          value: x.value ?? "",
          label: x.label ?? "",
        }))}
        cachingOptions={{
          lastUpdateTime,
          expiryPeriodMs: EXPIRY_PERIOD_MS,
          updateData: updateSelectModels,
          shouldUpdateOnLoad: purchaseAccountSelectModels.length === 0,
        }}
        defaultSelected={
          defaultSelected !== undefined
            ? { value: defaultSelected.value ?? "", label: defaultSelected.label ?? "" }
            : undefined
        }
        disabled={disabled}
        enableReinitialise={enableReinitialise}
      />
    </ActivityIndicator>
  );
};

export default PurchaseAccountSelect;
